import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import i18n from "./i18n";
import vueVirtualScroller from "vue-virtual-scroller";
import VueSelectSides from "vue-select-sides-forked";
import DashboardPlugin from "./plugins/dashboard-plugin";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "./helpers/directives/index";

Vue.use(DashboardPlugin);
Vue.use(vueVirtualScroller);

Vue.use(VueSelectSides, {
  locale: "pt_BR",
});

Vue.component("RecycleScroller", vueVirtualScroller.RecycleScroller);
Vue.component("vue-select-sides", VueSelectSides);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
  i18n,
});
